import { Pipe } from '@angular/core';

// Tell Angular2 we're creating a Pipe with TypeScript decorators
@Pipe({
    name: 'groupPipe'
})
export class GroupPipe {
    // Transform is the new "return function(value, args)" in Angular 1.x
    transform(value, args?) {
        // ES6 array destructuring
        let val;
        let str;
        let name;
        let description;
        if (args) {
            args = args.toLowerCase();
            return value.filter(group => {
            name = group.name.toString().toLowerCase();
            description = group.description.toString().toLowerCase();;
             if(name.indexOf(args) >= 0){
                 return group;
             }
              if(description.indexOf(args) >= 0){
                 return group;
             }
            });
        }
        else {
            return value;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/group.search.ts